<script>
export default {
    props: {
        user_hash: {
            required: true,
            type: String
        }
    },
    computed: {
        months() {
            return _.map({'JAN': '01', 'FEB': '02', 'MAR': '03', 'APR': '04', 'MEI': '05', 'JUN': '06', 'JUL': '07', 'AGU': '08', 'SEP': '09', 'OKT': '10', 'NOV': '11', 'DES': '12'}, (n,m) =>  ({
                key:  n,
                title: m,
                align: 'center',
                width: 80,
                scopedSlots: { customRender: 'month_' + n}
            }))
        },
        columns() {
            let collection = [
                {
                    key: 'year',
                    title: 'Tahun',
                    align: 'center',
                    width: 100,
                    scopedSlots: { customRender: 'year'}
                }
            ]
            _.each(this.months, (i) => collection.push(i))
            collection.push({
                key: 'final',
                title: 'Nilai Akhir',
                align: 'center',
                width: 80,
                scopedSlots: { customRender: 'final'}
            })
            return collection
        },
        /**
         years() {
            let years = []
            let cursor = this.start.clone()

            while(cursor < this.end || this.end.format('YYYY') === cursor.format('YYYY')) {
                years.push({
                    year: cursor.format('YYYY')
                })
            }

            return years
        }
         */
    },
    data: () => ({
        start: null,
        end: null,
        loading: false,
        objectives: [],
        scores: {}
    }),
    created() {
        this.start = this.moment(this.$laravel.training.date_start)
        this.end = this.moment(this.$laravel.training.date_end)

        this.getObjectives()
    },
    methods: {
        getObjectives() {
            this.loading = true
            this.$http
                .get(this.routeUri('api.performance.implementation'), {
                    params: {
                        cat: 'PRF-SOC',
                        user: this.user_hash
                    }
                })
                .then(r => this.objectives = r.data.objectives)
                .catch(err => this.handleXhrError(err))
                .finally(() => this.loading = false)
        },
        notInTraining(period) {
            return ! this.moment(period, 'YYYYMM').isBetween(this.start.startOf('month'), this.end.endOf('month'), undefined, '[]')
        },
        scoreSummary(period){
            if (this.notInTraining(period))
                return 0

            if (this.objectives.length < 1 || this.objectives[0].scores.length < 1)
                return 0

            let scores = 0
            this.objectives.forEach(function(item) {
                scores += parseFloat(item.scores[0].breakdown['score_' + period])
            })

            this.scores['score_' + period] = scores.toFixed(2)

            return scores.toFixed(2)
        },
        countFinalScore(period) {
            let divider = 0
            let score = 0
            let vm = this.scores
            this.months.forEach(function(item) {
                if(parseInt(vm['score_' + period + item.key]) != 0){
                    if(vm['score_' + period + item.key] != undefined){
                        score += parseFloat(vm['score_' + period + item.key])
                        divider++
                    }
                }
                
            })

            if(divider == 0)
                return 0

            return (score/divider).toFixed(2)
        },
        back() {
            window.location.href = this.routeUri('admin.performance.scoring')
        },
    },
}
</script>

<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Penilaian Soft Competency" @back="back">
            <common-training-header :withUser="true" :user_hash="user_hash" />
        </a-page-header>
        <a-card type="inner" size="small">
            <a-skeleton :loading="loading" active>
                <a-table :columns="columns" :dataSource="[ {year: '2021' }]" :pagination="false" rowKey="year" class="pcp-table">
                    <div slot="year" slot-scope="r">
                        <h4> <strong>{{ r.year }}</strong> </h4>
                    </div>
                    <template v-for="m in months" slot-scope="r" :slot="m.scopedSlots.customRender">
                        <a-button :disabled="notInTraining(r.year + m.key)" size="small" type="primary" :href="routeUri('admin.performance.scoring.soft-competency.show', { user: user_hash, period: r.year + '-' + m.key })">
                            {{ scoreSummary(r.year + m.key) }}
                        </a-button>
                    </template>
                    <div slot="final" slot-scope="r" class="text-center">
                        <strong> {{ countFinalScore(r.year)}}</strong>
                    </div>
                </a-table>
            </a-skeleton>
        </a-card>
    </div>
</template>
